<template>
  <div>
	<div v-if="navigationProgress.visible" class="route-progress" role="progressbar" aria-busy="true"></div>
	<router-view/>
	<template v-if="active">
		<v-dialog
			v-model="alertdialog"
			transition="dialog-top-transition"
			max-width="290"
		>
			<template>
			<v-card>
				<v-card-title class="text-h5"> {{$t('warning')}} </v-card-title>

				<v-card-text> {{$t('systemAutoLogout')}} </v-card-text>

				<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn color="grey darken-1" text v-on:click="closeAlert(false)">
					{{$t('cancel')}}
				</v-btn>
				</v-card-actions>
			</v-card>
			</template>
		</v-dialog>
		</template>
	</div>
</template>

<script>
import { isIndonesianClient, setDocumentBranding } from '@/utils';
import { navigationProgress } from '@/router/navigationProgress';

export default {

	data() {
    return {
      navigationProgress,
      events: ["click", "mousemove", "mousedown", "scroll", "load", "keypress"],
      warningTimer: null,
      logoutTimer: null,
      alertdialog: false,
      active: false,
    };
  },
  mounted() {
    this.setFavICON();
    this.events.forEach((event) => {
      window.addEventListener(event, this.resetTimer);
    }, this);
    //this.setTimers();
    // console.log("here ", JSON.stringify(store.getters))
  },
  destroyed() {
    this.events.forEach((event) => {
      window.removeEventListener(event, this.resetTimer);
    }, this);
    this.resetTimer();
  },
  watch: {
    // Reactively update title/favicon whenever the logged-in user changes
    '$store.state.auth.user': {
      deep: true,
      handler() {
        this.setFavICON();
      },
    },
    // Reactively update title/favicon when navigating to/from the PTSI login page
    '$route.name': {
      handler() {
        this.setFavICON();
      },
    },
  },
  methods: {
    setTimers() {
    },

    resetTimer() {
      // console.log("off")
      // clearTimeout(this.warningTimer),
      //   clearTimeout(this.logoutTimer),
      //   this.setTimers();
    },
    setFavICON() {
      setDocumentBranding(isIndonesianClient() || this.$route.name === 'loginPTSI');
    },
  },
};
</script>

<style lang="scss">
* {
  font-family: "Poppins", sans-serif;
}

.route-progress {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 5px;
  overflow: hidden;
  pointer-events: none;
}
.route-progress::before {
  content: "";
  position: absolute;
  top: 0;
  left: -40%;
  width: 40%;
  height: 100%;
  background: var(--v-primary-base, #0ebf67);
  animation: route-progress-slide 1s ease-in-out infinite;
}
@keyframes route-progress-slide {
  from { left: -40%; }
  to { left: 100%; }
}

@font-face {
	font-family: pop_light;
	src: url('/font/Poppins-Light.ttf');
}
@font-face {
	font-family: pop_regular;
	src: url('/font/Poppins-Regular.ttf');
}
@font-face {
	font-family: Poppins-Medium;
	src: url('/font/Poppins-Medium.ttf');
}
@font-face {
	font-family: pop_semiBold;
	src: url('/font/Poppins-SemiBold.ttf');
}

</style>
